<script>
  export let onClose;
</script>

<h3 class="text-lg font-semibold mb-4">Cài đặt</h3>

<div class="space-y-3 text-sm">
  <div class="flex justify-between">
    <span>Thông báo</span>
    <input type="checkbox" checked />
  </div>

  <div class="flex justify-between">
    <span>Chế độ tối</span>
    <input type="checkbox" />
  </div>
</div>

<button class="w-full mt-6 py-2 bg-gray-200 rounded-lg" on:click={onClose}>Đóng</button>
